import React, { useEffect, useState } from 'react'
import { callApi } from '../../api/callApi';
import { API_ENDPOINT, API_URL_2 } from '../../api/constant';
import RecentOrders from '../../components/common/RecentOrders';
import OrderMonitorHeader from '../../components/Layout/OrderMonitorHeader';

const OrderMoniterDashboard: React.FC = () => {
    const [orderCounts, setOrderCounts] = useState<any>();
    const [selectedStatus, setSelectedStatus] = useState<
        'All' | 'PENDING' | 'ACCEPTED' | 'PICKED UP' | 'ON THE WAY' | 'DELIVERED' | 'CANCELLED'
    >('All');
    useEffect(() => {
        fetchDashboardData()
    }, [])

    const fetchDashboardData = async () => {
        const response = await callApi(API_URL_2 + API_ENDPOINT.order + 'order-moniter-dashboard', { method: 'GET' });
        setOrderCounts(response);
    }

    const orderIcon = `<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" class="bi bi-box" viewBox="0 0 16 16"><path d="M8.186 1.113a.5.5 0 0 0-.372 0L1.846 3.5 8 5.961 14.154 3.5zM15 4.239l-6.5 2.6v7.922l6.5-2.6V4.24zM7.5 14.762V6.838L1 4.239v7.923zM7.443.184a1.5 1.5 0 0 1 1.114 0l7.129 2.852A.5.5 0 0 1 16 3.5v8.662a1 1 0 0 1-.629.928l-7.185 2.874a.5.5 0 0 1-.372 0L.63 13.09a1 1 0 0 1-.63-.928V3.5a.5.5 0 0 1 .314-.464z"/></svg>`
    return (
        <div className='app' >
            <OrderMonitorHeader />
            <div className="app-content pt-3 p-md-3 p-lg-4">
                <div className="container-xl">
                    <h2 className="app-page-title">Meatery Order Moniter</h2>
                    <div className="row g-4 mb-2 dashboardcards">
                        {[
                            {
                                title: "Total Orders",
                                value: orderCounts?.totalOrdersCount,
                                color: "text-success",
                                icon: `<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" class="bi bi-bar-chart" viewBox="0 0 16 16"><path d="M4 11H2v3h2zm5-4H7v7h2zm5-5v12h-2V2zm-2-1a1 1 0 0 0-1 1v12a1 1 0 0 0 1 1h2a1 1 0 0 0 1-1V2a1 1 0 0 0-1-1zM6 7a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v7a1 1 0 0 1-1 1H7a1 1 0 0 1-1-1zm-5 4a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v3a1 1 0 0 1-1 1H2a1 1 0 0 1-1-1z"/></svg>`,
                                onClick: () => setSelectedStatus('All')
                            },
                            {
                                title: "Pending Orders",
                                value: orderCounts?.pendingOrdersCount,
                                color: "text-danger",
                                icon: orderIcon,
                                onClick: () => setSelectedStatus('PENDING')
                            },
                            {
                                title: "Accepted Orders",
                                value: orderCounts?.acceptedOrdersCount,
                                icon: orderIcon,
                                onClick: () => setSelectedStatus('ACCEPTED')
                            },
                            {
                                title: "Picked Up",
                                value: orderCounts?.pickedUpOrdersCount,
                                icon: orderIcon,
                                onClick: () => setSelectedStatus('PICKED UP')
                            },
                            {
                                title: "On The Way",
                                value: orderCounts?.onTheWayOrdersCount,
                                icon: orderIcon,
                                onClick: () => setSelectedStatus('ON THE WAY')
                            },
                            {
                                title: "Delivered",
                                value: orderCounts?.deliveredOrdersCount,
                                icon: orderIcon,
                                onClick: () => setSelectedStatus('DELIVERED')
                            },
                            {
                                title: "Cancelled",
                                value: orderCounts?.cancelledOrdersCount,
                                icon: orderIcon,
                                onClick: () => setSelectedStatus('CANCELLED')
                            },
                        ].map((card, index) => (
                            <div className="col-md-3 cardsnew" style={{ cursor: "pointer" }} key={index} onClick={card.onClick}>
                                <div className="app-card innrecard app-card-orders-table shadow-sm mb-4 p-4">
                                    <h5 className='text-primary d-flex align-items-center justify-content-between gap-3'>
                                        {card.title}
                                        <span dangerouslySetInnerHTML={{ __html: card.icon }} />
                                    </h5>
                                    <p>{card.value}</p>
                                </div>
                            </div>
                        ))}
                    </div>
                    <div className="row g-4 mb-4">
                        <div className="col-md-12">
                            <RecentOrders isOrderMoniter={true} selectedStatus={selectedStatus} />
                        </div>
                    </div>
                </div>
            </div>

        </div>
    )
}

export default OrderMoniterDashboard